import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_mct6ez8kpr: FaireCollectionEntity = {
  token: "pbc_mct6ez8kpr",
  type: "collection",
  name: "Pre-Order (2T-3T Sizes) FW26 Joyful Days Organic Sweater",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a0bfa973cee51a05c84664a3c1978a74fadb975757e65d6ea726249381d45059.png",
  itemCount: 6,
  description:
    "FW26 Organic baby sweater knit styles that are available in 2T and 3T sizes.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:16.158Z",
    importedBy: "entity-db-import-collections",
  },
};
